import { getConfigName } from "@helpers/funciones";
import QuotationModalDefault from "@components/QuotationModalDefault";
import QuotationModalCredivive from "../pages/producto/credito_simple/credivive/QuotationModalCredivive";
import QuotationModalMoto from "../pages/producto/credito_simple/micredimoto/QuotationModalMoto";
import QuotationModalVivemoto from "../pages/producto/credito_simple/vivemoto/QuotationModalVivemoto";

const quotationModalsComponent: Record<string, React.FC> = {
  credivive: QuotationModalCredivive,
  micredimoto: QuotationModalMoto,
  vivemoto: QuotationModalVivemoto,
};

export const QuotationModal = () => {

  const configName = getConfigName(window.location.href);

  const Component = quotationModalsComponent[configName];

  if (!Component) {
    return <QuotationModalDefault />;
  }

  return <Component />;
};
